import React from 'react'
import Navbar from '../components/Navbar'
import Form from '../components/BuyForm'
import BuyForm from '../components/BuyForm'
import SellForm from '../components/SellForm'

const Sell = () => {
  return (
    <div>
        <Navbar/>
        <SellForm/>
    </div>
  )
}

export default Sell